<template>
    <div class="progress">
        <div v-if="showSuccessMessage && !done" class="slideInDownDelay">
            <div class="row justify-center px-3">
                <v-alert class="my-3 w-100" type="success">You are ready to go</v-alert>
            </div>
        </div>
        <div v-if="!showSuccessMessage && !done">
            <v-stepper class="elevation-0" non-linear :value="value">
                <v-stepper-header>
                    <v-stepper-step @click="goTo(item.url)" v-for="(item, index) in progress" :complete="item.done" editable :step="index + 1">{{item.name}}</v-stepper-step>
                </v-stepper-header>
            </v-stepper>
            <v-alert v-if="desc" class="mx-5" type="info">{{desc}}</v-alert>
        </div>
    </div>
</template>
<script>
    export default {
        data:() => {
            return{
                showSuccessMessage: false,
                last: 0,
                initialized: false,
                done: false,
            }
        },
        watch:{
            progress: function () {
                if(this.progress){
                    var now = this.progress.filter(x => x.done == false).length;
                    if(this.last == 0 && now == 0){
                        this.done = true;
                    }
                    if(this.initialized && now == 0 && this.last > 0){
                        this.showSuccessMessage = true;
                        setTimeout(() => {
                            this.done = true;
                        }, 5000)
                    }
                    this.last = this.progress.filter(x => x.done == false).length;
                }
            }
        },
        mounted(){
          setTimeout(() => {
              this.initialized = true;
              if(this.progress){
                  var now = this.progress.filter(x => x.done == false).length;
                  if(this.last == 0 && now == 0){
                      this.done = true;
                  }
              }
          },500)
        },
        computed:{
            progress(){
                return this.$store.getters.progress;
            },
            value(){
                var val = 0;
                if(this.progress){
                    this.progress.forEach((item,index) => {
                        if(item.url == this.$route.path) val = index + 1;
                    })
                }
                return val;
            },
            desc(){
                if(this.progress && this.value){
                    if(this.progress[this.value - 1] && this.progress[this.value - 1].desc && !this.progress[this.value - 1].done){
                        return this.progress[this.value - 1].desc;
                    }
                }
                return null;
            }
        },
        methods:{
            goTo(link){
                this.$router.push(link);
            }
        }
    }
</script>
<style lang="scss">
    .progress{
        .v-icon{
            color: white !important;
        }
    }
</style>
